import actions from '../../actionTypes';

export default (id, data = []) => {
  return {
    type: actions.SET_HISTORY,
    id,
    data
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/setHistory.js